import { render, staticRenderFns } from "./ECommerceCheckoutStepCart.vue?vue&type=template&id=56ec5cc6&"
import script from "./ECommerceCheckoutStepCart.vue?vue&type=script&lang=js&"
export * from "./ECommerceCheckoutStepCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports